import axios from './axios';

const confinementServices = {
  fetch: () => {
    const options = {
      method: 'GET',
      url: 'confinements'
    };

    return axios(options);
  }
};

export default confinementServices;
